import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';

import {
  answerSelfPromotion,
  fetchPendingSelfPromotions,
} from '../../actions/selfPromotionActions';
import ModalBase from '../ModalBase/ModalBase';
import { getUser } from '../User/userSelectors';

function SelfPromotionModal() {
  const dispatch = useDispatch();
  const user = useSelector(getUser);
  const { pending, answering, answerError } = useSelector(
    (state) => state.selfPromotion,
  );
  const [dismissed, setDismissed] = useState(false);
  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    if (user?.id && !fetched) {
      dispatch(fetchPendingSelfPromotions());
      setFetched(true);
    }
  }, [dispatch, user, fetched]);

  if (!user?.id || dismissed || pending.length === 0) {
    return null;
  }

  const current = pending[0];

  const handleAnswer = (answer) => {
    dispatch(
      answerSelfPromotion(
        current.configId,
        current.cycleId,
        current.rank,
        answer,
      ),
    );
  };

  const handleClose = () => setDismissed(true);

  return (
    <ModalBase
      isOpen
      toggle={handleClose}
      header={<>Were You Promoted?</>}
      body={
        <>
          <p>
            Let us know if you were promoted on the {current.rank} exam (
            {current.cycleTitle}).
          </p>
          {answerError && <div className="message-error">{answerError}</div>}
        </>
      }
      footer={
        <>
          <Button
            className="btn modal-base-btn primary"
            disabled={answering}
            onClick={() => handleAnswer('yes')}
          >
            Yes, I was promoted!
          </Button>
          <Button
            className="btn modal-base-btn secondary"
            disabled={answering}
            onClick={() => handleAnswer('no')}
          >
            No, I wasn&apos;t promoted
          </Button>
        </>
      }
    />
  );
}

export default SelfPromotionModal;
